export default __webpack_public_path__ + "static/media/banner-1.89d60cc1.jpg";